import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ShareDataService } from '../../shared/utils/share-data.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  shareDataService = inject(ShareDataService);
  
   constructor(private router: Router) {  
    this.shareDataService.setData("Welcome")

   }

  goHome() {
    this.router.navigate(['/']);
  }
}
